export default () => ({
    init() {
        let expandables = this.$el.querySelectorAll('.menu-item-has-children');
        [...expandables].forEach((v,i,a) => {
            
        });
    }
});